// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.logo-height-big{height:36px}.logo-in-sign{margin-bottom:28px;width:100%}`, "",{"version":3,"sources":["webpack://./src/share/Logo/index.scss"],"names":[],"mappings":"AAAA,iBACC,WAAA,CAGD,cACC,kBAAA,CACA,UAAA","sourcesContent":[".logo-height-big {\n\theight: 36px;\n}\n\n.logo-in-sign {\n\tmargin-bottom: 28px;\n\twidth: 100%;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
